module.exports = __webpack_public_path__ + "f984e15013af7b4e5649cfdfaa4cfb44.ttf";